import type { EditAdmissionSimulationFormProps } from './types'

export const initialFormValues: EditAdmissionSimulationFormProps = {
  position: '',
  startDate: '',
  salary: ''
}
